import styles from "./ConciergeBookingWidget.module.scss";

import { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";

import { useCoachingApi } from "@/modules/coaching/shared/hooks/useCoachingApi";
import { CalendlyWidget } from "@/modules/shared/components/CalendlyWidget";
import { ErrorIcon } from "@/modules/shared/svgs/ErrorIcon";
import { Route } from "@/routes/embed/concierge-booking";

/**
 * @deprecated Legacy Calendly concierge booking. Replaced by the native Coach
 * Matching flow at /embed/coach-matching (CoachMatchingWidget). Retained only as
 * the migration fallback per MEM-866; remove once Calendly is retired.
 */
export const ConciergeBookingWidget = () => {
  const { t } = useTranslation();
  const { calendlyUrl, name, email, utmCampaign, utmMedium, utmSource } =
    Route.useSearch();
  const [hasError, setHasError] = useState(false);

  const { confirmBookingSession } = useCoachingApi();

  const handleLoadError = useCallback(() => setHasError(true), []);

  const handleBooking = async (
    eventUri: string,
    inviteeUri?: string | undefined,
  ) => {
    try {
      if (!inviteeUri) {
        throw new Error("Invitee URI is required");
      }
      await confirmBookingSession({
        sessionId: utmCampaign,
        eventUri,
        inviteeUri,
      });
    } catch (error) {
      console.error(error);
    }
  };

  if (hasError) {
    return (
      <div className={styles.errorContainer}>
        <ErrorIcon />
        <div className={styles.errorTextBlock}>
          <h1 className={styles.errorTitle}>
            {t("conciergeBooking.errors.title")}
          </h1>
          <p className={styles.errorBody}>
            {t("conciergeBooking.errors.description")}
            <br aria-hidden="true" />
            <br aria-hidden="true" />
            {t("conciergeBooking.errors.support")}
          </p>
        </div>
      </div>
    );
  }

  return (
    <CalendlyWidget
      url={calendlyUrl}
      onEventScheduled={handleBooking}
      prefillData={{ name, email }}
      utm={{
        utmSource,
        utmMedium,
        utmCampaign,
      }}
      disableMarginTop
      onLoadError={handleLoadError}
    />
  );
};
